export var ChargeCardType;
(function (ChargeCardType) {
    ChargeCardType["ChargeCard"] = "ChargeCard";
    ChargeCardType["KeyFob"] = "Druppel";
})(ChargeCardType || (ChargeCardType = {}));
